function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
import formControlState from '@material-ui/core/FormControl/formControlState';
import useFormControl from '@material-ui/core/FormControl/useFormControl';
import propTypeComponent from '@signal/prop-types/component';
import { Label } from './styles';
export var FormLabel = /*#__PURE__*/memo(function FormLabel(props) {
  var children = props.children,
      other = _objectWithoutProperties(props, ["children"]);

  var muiFormControl = useFormControl();
  var states = ['required', 'focused', 'disabled', 'error'];
  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: states
  });
  var color = 'textPrimary';
  if (fcs.disabled) color = 'textSecondary';
  if (fcs.error) color = 'error';
  return /*#__PURE__*/React.createElement(Label, Object.assign({
    color: color
  }, omit(other, states)), children, fcs.required && /*#__PURE__*/React.createElement("span", null, "\u2009*"));
});
FormLabel.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: propTypeComponent,

  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: PropTypes.bool,

  /**
   * @ignore
   */
  muiFormControl: PropTypes.object,

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: PropTypes.bool
};
FormLabel.defaultProps = {
  component: 'label'
};
export default FormLabel;